import { Routes } from '@angular/router';
import { AuthGuard } from '../app/guards/auth.guard';
import { ConditionsComponent } from './components/conditions/conditions.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { MySettingsComponent } from './components/my-settings/my-settings.component';
import { ParkingComponent } from './home/admin/back-office24/parkings/parking.component';
import { QrGeneratorComponent } from './components/qr-scanner/qr-generator/qr-generator.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { BookingServiceComponent } from './home/checkout/booking-service/booking-service.component';
import { HotelShuttleServiceListComponent } from './home/admin/hotel-shuttle-service-list/hotel-shuttle-service-list.component';
import { CheckoutPageComponent } from './home/checkout/checkout-page/checkout-page.component';
import { PaymentFailureComponent } from './home/checkout/payment-failure/payment-failure.component';
import { PaymentSuccessComponent } from './home/checkout/payment-success/payment-success.component';
import { ActivateUserComponent } from './home/admin/users/activate-user/activate-user.component';
import { UsersListComponent } from './home/admin/users/users-list/users-list.component';
import { ContactComponent } from './pages/contact/contact.component';
import { FindUsComponent } from './pages/find-us/find-us.component';
import { LoginComponent } from './pages/login/login.component';
import { PriserComponent } from './pages/priser/priser.component';
import { StartComponent } from './pages/start/start.component';
import { FaqComponent } from './pages/faq/faq.component';
import { ArrivalDepartureListComponent } from './home/admin/back-office24/arrivaldeparture/arrivaldeparture-list/arrivaldeparture-list.component';
import { SelfServiceComponent } from './home/self-service/self-service.component';
import { TUIComponent } from './pages/tui/tui.component';
import { NazarComponent } from './pages/nazar/nazarcomponent';
import { ArlandaparkeringComponent } from './pages/faq/arlandaparkering/arlandaparkering/arlandaparkering.component';
import { AdminStartComponent } from './components/admin-start/admin-start.component';
import { TermsComponent } from './pages/terms/terms.component';
import { LandingPageComponent2 } from './pages/landing-page-2/landing-page-2.component';
import { CustomerHomeComponent } from './pages/customer-home/customer-home.component';
import { ChatComponent } from './components/chat/chat.component';
import { HomeComponent } from './parkifly-bookings/organizations/pages/home/home.component';
import { StartBookingComponent } from './parkifly-bookings/organizations/features/booking/pages/start/start.component';
import { HandleBookingComponent } from './parkifly-bookings/organizations/pages/handle-booking/handle-booking.component';
import { HandleBookingDetailsComponent } from './parkifly-bookings/organizations/pages/handle-booking-details/handle-booking-details.component';
import { GeneralPaymentComponent } from './parkifly-bookings/components/payment/payment.component';
import { GeneralReceiptComponent } from './parkifly-bookings/components/receipt/receipt.component';
import { MyOrdersComponent } from './parkifly-bookings/components/my-orders/my-orders.component';
import { BookingOverviewComponent } from './parkifly-bookings/organizations/pages/booking-overview/booking-overview.component';
import { UpdateBookingComponent } from './parkifly-bookings/organizations/pages/update-booking/update-booking.component';
import { SimpleWidgetComponent } from './parkifly-bookings/components/widget/simple-widget/widget.component';
import { AdvancedWidgetComponent } from './parkifly-bookings/components/widget/advanced-widget/advanced-widget.component';
import { InternalBookingFormComponent } from './parkifly-bookings/organizations/features/booking/components/form/internal-booking/internal-booking-form/internal-booking-form.component';
import { WidgetTestComponent } from './components/widget-test/widget-test.component';
import { BackOffice24OrderShuttlePlanningComponent } from './home/admin/back-office24/back-office24-shuttle/back-office24-order-shuttle-planning/back-office24-order-shuttle-planning.component';
import { DriveUpBookingComponent } from './pages/drive-up-booking/drive-up-booking.component';
import { DriveInBookingComponent } from './pages/drive-in-booking/drive-in-booking.component';
import { DriveInFormComponent } from './pages/drive-in-form/drive-in-form.component';
import { DriveInDetailsFormComponent } from './pages/drive-in-details-form/drive-in-details-form.component';
import { ParkingPermitComponent } from "./pages/parking-permit/parking-permit.component";
import { QualityArlandaComponent } from './pages/quality-xpo-arlanda/quality-xpo-arlanda.component';
import { CancelTransferBookingComponent } from './parkifly-bookings/organizations/pages/cancel-transfer-booking/cancel-transfer-booking.component';
import { QualityXpoTwoDayBookingComponent } from './pages/quality-xpo-two-day-booking/quality-xpo-two-day-booking.component';
import { UpdateBookingSimpleComponent } from './parkifly-bookings/organizations/pages/update-booking-simple/update-booking-simple.component';
import { DriveUpDetailsFormComponent } from './pages/drive-up-details-form/drive-up-details-form.component';
import { ParkingAndTransferBookingComponent } from './parkifly-bookings/organizations/pages/parking-and-transfer-booking/parking-and-transfer-booking.component';
import { QualityBookingComponent } from './home/quality-booking/quality-booking.component';
import { AdditionalServicesComponent } from './parkifly-bookings/organizations/pages/additional-services/edit-booking-additional-services.component';
import { CancelAdditionalServicesComponent } from './parkifly-bookings/organizations/pages/cancel-additional-services/cancel-additional-services.component';
import { ParkAndFlyAdvancedWidgetComponent } from './parkifly-bookings/components/widget/park-and-fly-advanced-widget/park-and-fly-advanced-widget.component';
import { ShortTermWidgetComponent } from './parkifly-bookings/components/widget/short-term-widget/short-term-widget.component';
import { AidenShortTermWidgetComponent } from './parkifly-bookings/components/widget/aiden-short-term-widget/aiden-short-term-widget.component';
import { AidenParkAndFlyAdvancedWidgetComponent } from './parkifly-bookings/components/widget/aiden-park-and-fly-advanced-widget/aiden-park-and-fly-advanced-widget.component';
import { TermsAndConditionsComponent } from './parkifly-bookings/organizations/pages/terms-and-conditions/terms-and-conditions.component';

import { SearchResultsComponent } from './pages/search-results/search-results.component';

export const ROUTES: Routes = [
  // ShuttleBuss
  { path: '', component: StartComponent },
  { path: 'start', component: StartComponent },
  { path: 'customer-portal', component: CustomerHomeComponent },
  { path: 'parkifly-home', component: CustomerHomeComponent },
  { path: 'parkifly/search-results', component: SearchResultsComponent },
  { path: 'search-results', component: SearchResultsComponent },
  { path: 'booking-service/:organizationId', component: BookingServiceComponent },
  { path: 'booking-service-list/:organizationId', component: HotelShuttleServiceListComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'qr/:id', component: QrGeneratorComponent },
  { path: 'activateuser', component: ActivateUserComponent },
  { path: 'login', component: LoginComponent },
  { path: 'self-service', component: SelfServiceComponent },
  { path: 'selfservice', component: SelfServiceComponent },
  { path: 'customer', component: HandleBookingComponent },
  { path: 'kund', component: HandleBookingComponent },
  { path: 'cancel-transfer-booking', component: CancelTransferBookingComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },

  // ShuttleBuss Admin
  { path: 'admin/admin-start', component: AdminStartComponent, canActivate: [AuthGuard] },
  { path: 'admin/arrivaldeparture-list', component: ArrivalDepartureListComponent, canActivate: [AuthGuard] },
  { path: 'parking/:organizationId', component: ParkingComponent, canActivate: [AuthGuard] },
  { path: 'users-list', component: UsersListComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'settings', component: MySettingsComponent, canActivate: [AuthGuard] },
  { path: 'chat', component: ChatComponent, canActivate: [AuthGuard] },

  { path: 'app-short-term-widget', component: ShortTermWidgetComponent },
  { path: 'app-aiden-short-term-widget', component: AidenShortTermWidgetComponent },
  { path: 'park-and-fly-advanced-widget-booking', component: ParkAndFlyAdvancedWidgetComponent },
  { path: 'aiden-park-and-fly-advanced-widget-booking', component: AidenParkAndFlyAdvancedWidgetComponent },
  { path: 'advanced-widget-booking', component: AdvancedWidgetComponent },
  { path: 'simple-widget-booking', component: SimpleWidgetComponent },
  { path: 'widget-test', component: WidgetTestComponent },

  // Flygets
  { path: 'flygets/flygets-start', component: LandingPageComponent2 },
  { path: 'flygets/priser', redirectTo: 'flygets/flygets-start', pathMatch: 'full' },
  { path: 'flygets/hitta-hit', component: FindUsComponent },
  { path: 'flygets/kontakta-oss', component: ContactComponent },
  { path: 'flygets/payment/success', component: PaymentSuccessComponent },
  { path: 'flygets/payment/failure', component: PaymentFailureComponent },
  { path: 'flygets/checkout/payment/:orderId', component: CheckoutPageComponent },
  { path: 'flygets/checkout/receipt/:orderId/:configType', component: PaymentSuccessComponent },
  { path: 'flygets/checkout/receipt/:orderId', component: PaymentSuccessComponent },
  { path: 'flygets/conditions', component: ConditionsComponent },
  { path: 'flygets/faq', component: FaqComponent },
  { path: 'flygets/faq/arlandaparkering', component: ArlandaparkeringComponent },
  { path: 'tui', component: TUIComponent },
  { path: 'nazar', component: NazarComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'drivein', component: DriveInFormComponent },
  { path: 'parkifly/drive-in-details-form', component: DriveInDetailsFormComponent },
  { path: 'parkifly/drive-in-booking', component: DriveInBookingComponent },
  { path: 'parkifly/p2', component: ParkingPermitComponent },
  { path: 'parkifly/drive-up-details-form', component: DriveUpDetailsFormComponent },
  { path: 'parkifly/drive-up-booking', component: DriveUpBookingComponent },
  // { path: 'parkifly/quality-xpo-arlanda', component: QualityArlandaComponent },
  // { path: 'parkifly/parking-and-transfer/:org', component: ParkingAndTransferBookingComponent },
  { path: 'parkifly/quality-xpo-arlanda', component: QualityXpoTwoDayBookingComponent },
  { path: 'parkifly/aiden-short-term', component: QualityXpoTwoDayBookingComponent },
  { path: 'parkifly/quality-xpo-arlanda-parkandfly', component: ParkingAndTransferBookingComponent },
  { path: 'parkifly/aiden-parkandfly', component: ParkingAndTransferBookingComponent },

  // Internal booking
  { path: 'internal-booking', component: InternalBookingFormComponent, canActivate: [AuthGuard] },

  // Parkifly bookings
  { path: 'parkifly/edit-parking-additional-services', component: AdditionalServicesComponent },
  { path: 'parkifly/cancel-additional-services', component: CancelAdditionalServicesComponent },
  { path: 'parkifly/quality-landing-page', component: QualityBookingComponent },
  { path: 'parkifly/aiden-landing-page', component: QualityBookingComponent },
  { path: 'parkifly/my-orders/:org', component: MyOrdersComponent, canActivate: [AuthGuard] },
  { path: 'parkifly/booking-overview', component: BookingOverviewComponent },
  { path: 'parkifly/update-booking', component: UpdateBookingSimpleComponent },
  { path: 'parkifly/edit-parking', component: UpdateBookingComponent },
  { path: 'parkifly/:org/booking', component: StartBookingComponent },
  { path: 'parkifly/handle-booking', component: HandleBookingComponent },
  { path: 'parkifly/:organization', component: HomeComponent },
  { path: 'parkifly/handle-booking/details', component: HandleBookingDetailsComponent },
  { path: 'parkifly/:organization/checkout/payment/:orderId', component: GeneralPaymentComponent },
  { path: 'parkifly/:organization/checkout/receipt/:orderId/:configType', component: GeneralReceiptComponent },
  { path: 'parkifly/parking-and-transfer/:org/booking', component: StartBookingComponent },

  // Alternative route paths for parkifly booking components
  { path: 'parkifly-new/my-orders/:org', component: MyOrdersComponent, canActivate: [AuthGuard] },
  { path: 'parkifly-new/cancel-additional-services', component: CancelAdditionalServicesComponent },
  { path: 'parkifly-new/booking-overview', component: BookingOverviewComponent },
  { path: 'parkifly-new/update-booking', component: UpdateBookingSimpleComponent },
  { path: 'parkifly-new/edit-parking', component: UpdateBookingComponent },
  { path: 'parkifly-new/:org/booking', component: StartBookingComponent },
  { path: 'parkifly-new/handle-booking', component: HandleBookingComponent },
  { path: 'parkifly-new/:organization', component: HomeComponent },
  { path: 'parkifly-new/handle-booking/details', component: HandleBookingDetailsComponent },
  { path: 'parkifly-new/:organization/checkout/payment/:orderId', component: GeneralPaymentComponent },
  { path: 'parkifly-new/:organization/checkout/receipt/:orderId/:configType', component: GeneralReceiptComponent },
  { path: 'parkifly-new/parking-and-transfer/:org/booking', component: StartBookingComponent },
  { path: 'parkifly-new/quality-landing-page', component: QualityBookingComponent },
  { path: 'parkifly-new/aiden-landing-page', component: QualityBookingComponent },
  { path: 'parkifly-new/edit-parking-additional-services', component: AdditionalServicesComponent },

  // Temp Routes
  { path: 'flygets-start', component: LandingPageComponent2 },
  { path: 'priser', redirectTo: 'flygets-start', pathMatch: 'full' },
  { path: 'hitta-hit', component: FindUsComponent },
  { path: 'kontakta-oss', component: ContactComponent },
  { path: 'payment/success', component: PaymentSuccessComponent },
  { path: 'payment/failure', component: PaymentFailureComponent },
  { path: 'checkout/payment/:orderId', component: CheckoutPageComponent },
  { path: 'checkout/receipt/:orderId/:configType', component: PaymentSuccessComponent },
  { path: 'checkout/receipt/:orderId', component: PaymentSuccessComponent },
  { path: 'conditions', component: ConditionsComponent },

  // BackOffice24
  {
    path: 'admin',
    loadChildren: () => import('./home/admin/back-office24/back-office24.module').then(m => m.BackOffice24Module),
    canActivate: [AuthGuard]
  },

  //widget

  { path: '**', component: StartComponent },
];
